import { useRef } from "react";
import ReportCustomerFreeProductList from "./ReportCustomerFreeProductList";

const ReportCustomerFreeProductMain = (props) => {
  const listRef = useRef();

  return (
    <div className="col-start-start p-4 gap-4 w-100">
      <ReportCustomerFreeProductList ref={listRef} />
    </div>
  );
};

export default ReportCustomerFreeProductMain;
